import { CouponFeautreType } from '@aimpact-korea/arrange-front-types';
import {
  QueryFunctionContext,
  QueryKey,
  useQuery,
  UseQueryOptions
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { useErrorHandler } from 'react-error-boundary';
import axios from '../../../utils/axios';
import { FetchCouponPresetList } from '../coupon-preset/fetch-coupon-preset';

export namespace StoreCouponPresetList {
  export type ResponseType = {
    storeCouponPresets: {
      id: number;
      storeId: number;
      couponPresetId: number;
      showStartDate: number | null;
      showEndDate: number | null;
      expirationDay: number | null;
      deletedAt: number;
      updatedAt: string;
      createdAt: string;
      couponPreset: FetchCouponPresetList.ResponseType['couponPresetItems'][number];
    }[];
  };

  export type RequestType = {
    storeId?: number;
    couponFeautreType?: CouponFeautreType;
  };

  type TUseQueryOptions = UseQueryOptions<
    AxiosResponse<ResponseType>,
    AxiosError,
    AxiosResponse<ResponseType>,
    TQueryKey
  >;

  export const KEY_STRING = 'fetch-store-coupon-preset-list' as const;

  type TQueryKey = [typeof KEY_STRING, RequestType];
  type TQueryKey2 = TQueryKey & QueryKey;

  export async function fetchData({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    queryKey
  }: QueryFunctionContext<TQueryKey2>) {
    return await axios.get<ResponseType>(`/store-coupon-presets`, {
      params: {
        couponFeautreType: queryKey[1]?.couponFeautreType,
        storeId: queryKey[1]?.storeId
      }
    });
  }

  export const useFetchQuery = (
    { couponFeautreType, storeId }: RequestType = {},
    { ...props }: TUseQueryOptions = {}
  ) => {
    const errorHandler = useErrorHandler();

    const query = useQuery(
      [KEY_STRING, { couponFeautreType, storeId }],
      fetchData,
      {
        refetchOnWindowFocus: false,
        staleTime: 300000,
        onError: errorHandler,
        ...props
      }
    );

    return query;
  };
}
